import { useEffect, useState } from 'react';
import ConfettiBurst from './ConfettiBurst.jsx';
import { track } from '../utils/tracking.js';

// Secret reward for a perfect round. Renders only when score === total
// (callsite gates this). Fades in after a beat so the score animation
// finishes first and the unicorn lands as a payoff, not as decoration.
export default function UnicornUnlock({ score, total }) {
  const [shown, setShown] = useState(false);
  const [confettiKey, setConfettiKey] = useState(0);

  useEffect(() => {
    const t = setTimeout(() => {
      setShown(true);
      setConfettiKey(k => k + 1);
      track('unicorn_unlocked', { score, total });
    }, 1400);
    return () => clearTimeout(t);
  }, [score, total]);

  if (!shown) return null;

  return (
    <section className="unicorn-unlock">
      <div className="unicorn-confetti-wrap">
        <ConfettiBurst key={confettiKey} count={32} />
      </div>
      <img
        className="unicorn-img"
        src="/ed-the-unicorn.png"
        alt="Unicorn-Ed, the rare reward for a perfect round"
      />
      <div className="unicorn-meta">
        <p className="unicorn-eyebrow">Rare unlock</p>
        <h3 className="unicorn-title">Unicorn-Ed</h3>
        <p className="unicorn-sub">A perfect round. Hardly anyone gets here.</p>
      </div>
    </section>
  );
}
